import utils from '../utils'
import api from '../apis'
const cacheKey = 'loginState';
export default {
  state: {
    loginState: utils.cache(cacheKey),
    ticket: {}
  },
  getters: {
    isLogin(state) {
      return state.loginState;
    },
    ticketInfo(state) {
      return state.ticket;
    }
  },
  mutations: {
    loginSucc(state) {
      state.loginState = true;
      utils.cache(cacheKey, true)
    },
    logoutSucc(state) {
      utils.cache(cacheKey, false)
      state.loginState = false;
      state.ticket = {};
    },
    setTicketInfo(state, ticketInfo) {
      state.ticket = ticketInfo;
    }
  },
  actions: {
    logout({
      commit
    }) {
      return api.system.logout().then(function (response) {
        commit('logoutSucc')
        return response;
      }).catch(function () {
        commit('logoutSucc')
        return response;
      });
    },
    login({
      commit
    }, loginInfo) {
      return api.system.login(loginInfo).then(function (response) {
        if (response.data.isSucc) {
          commit('setTicketInfo', response.data.result)
          commit('loginSucc')
        }
        return response;
      });
    },
    loadTicketInfo({
      commit
    }, options) {
      return api.system.getTicketInfo(options).then(function (response) {
        if (response.data.isSucc) {
          commit('setTicketInfo', response.data.result);
        }
        return response;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ticketStore.js